<template>
  <v-container fluid>
    <HomeKPI :dashboard="dashboard" />
    <v-row>
      <v-col class="cols-md-12 cols-6">
        <ProjectList :projects="dashboard.projects" />
      </v-col>
      <v-col class="cols-md-12 cols-6">
        <TaskToCome
          :tasks="dashboard.tasks"
          :shortList="true"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { ProjectService } from "@/services"

export default {
  name: "Home",
  components: {
    HomeKPI: () => import("@/components/ri3/HomeKPI.vue"),
    ProjectList: () => import("@/components/ri3/ProjectList.vue"),
    TaskToCome: () => import("@/components/ri3/TaskToCome.vue")
  },
  data() {
    return {
      dashboard: {
        projects: [],
        tasks: []
      }
    }
  },
  created() {
    this.home()
  },
  methods: {
    home() {
      ProjectService.getHome().then(result => {
        this.dashboard = result
      })
    }
  }
}
</script>
